import { render, staticRenderFns } from "./ed-select-custom-dropdown.vue?vue&type=template&id=04f50aa9&scoped=true&"
import script from "./ed-select-custom-dropdown.ts?vue&type=script&lang=ts&"
export * from "./ed-select-custom-dropdown.ts?vue&type=script&lang=ts&"
import style0 from "./ed-select-custom-dropdown.scss?vue&type=style&index=0&id=04f50aa9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f50aa9",
  null
  
)

export default component.exports